import './Title.scss'
import React from 'react'
import PropTypes from 'prop-types'

const Title = ({ size = 'default', color = 'default', children }) =>
  <h3 className={ `widget-typography-title size-${ size } color-${ color }` }>
    { children instanceof Array
      ? children.map(text => text.replace(/\s/g, ' '))
      : children.replace(/\s/g, ' ')
    }
  </h3>

Title.propTypes = {
  size: PropTypes.oneOf(['default', 'small', 'large', 'extra-large']),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  color: PropTypes.oneOf(['default', 'light-mobile']),
}

export default Title
